import { Stack, MenuItem, useTheme, useMediaQuery } from "@mui/material";
import { FormInput, FormTimePicker } from "src/components";
import {
    returnTripOptions,
    validateByCalendar,
    ReturnTripTypes,
} from "../helpers";
import { authSelector } from "src/modules/auth/redux/authSlice";
import { PassioService } from "src/types";
import { useAppSelector } from "src/hooks";
import { useFormikContext } from "formik";
import { TripRequestFormValues } from "../types";
import { Client } from "src/modules/auth/types";
import moment from "moment";

interface Props {
    client: Client;
    disablePast: boolean;
}

const ReturnTripOptions = ({ client, disablePast = true }: Props) => {
    const { service } = useAppSelector(authSelector);
    const { values, setFieldValue } = useFormikContext<TripRequestFormValues>();

    const theme = useTheme();
    const isMobileDevice = useMediaQuery(theme.breakpoints.down("md"));
    const isNavigator = service === PassioService.navigator;
    /* How the rider is going to get back. 0 = One way, 1 = Call for return, 2 = Specific return time requested */

    return (
        <Stack spacing={2} direction={{ xs: "column", md: "row" }}>
            {/* How the rider is going to get back. 0 = One way, 1 = Call for return, 2 = Specific return time requested */}
            <FormInput
                name="returnType"
                label="For my return trip, I'd like"
                select
                valueAsNumber
                SelectProps={{
                    native: isMobileDevice,
                }}
                sx={{ flexGrow: 1 }}
            >
                {returnTripOptions.map((item, index) => {
                    const show = isNavigator
                        ? item.value !== ReturnTripTypes.callForReturn
                        : true;

                    if (!show) return null;
                    return isMobileDevice ? (
                        <option key={index} value={item.value}>
                            {item.label}
                        </option>
                    ) : (
                        <MenuItem key={index} value={item.value}>
                            {item.label}
                        </MenuItem>
                    );
                })}
            </FormInput>
            {/* if roundtrip */}
            {values.returnType === ReturnTripTypes.specificTime && (
                <FormTimePicker
                    name="returnTime"
                    label="Return Pick Up Time"
                    sx={{ flexGrow: 1 }}
                    disablePast={disablePast}
                    minTime={values.apptTime}
                    validate={(date) => {
                        const { message } = validateByCalendar(
                            client,
                            date,
                            values.tripProgram,
                            "time"
                        );
                        return message;
                    }}
                    onChange={(date) => {
                        // ensure return date is the same as today
                        // @see TimeSelector and TripPrograms for other implementation
                        const apptInst = moment(values.apptTime);
                        const returnTime = moment(date).set({
                            date: apptInst.date(),
                            month: apptInst.month(),
                            year: apptInst.year(),
                        });

                        setFieldValue("returnTime", returnTime.toDate());
                    }}
                />
            )}
        </Stack>
    );
};

export default ReturnTripOptions;
